export default __webpack_public_path__ + "static/media/calender-image-booking.1a5404fe.jpg";